import { render } from "./BarcodeView.vue?vue&type=template&id=1897e529&scoped=true"
import script from "./BarcodeView.vue?vue&type=script&lang=js"
export * from "./BarcodeView.vue?vue&type=script&lang=js"

import "./BarcodeView.vue?vue&type=style&index=0&id=1897e529&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1897e529"]])

export default __exports__